<template>
  <section>
    <header>
      <h3>{{q}}</h3>
    </header>
    <div class="answer">
      <slot name="a"></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: ['q']
}
</script>
